import React from 'react';
import MarkdownIt from 'markdown-it/lib';



const md = new MarkdownIt({
    html: true,
    linkify: false,
});

const Snippet = ({ markdown, filename }) => {
    return (
        <div className="snippet">
            <div className='snippet__filename'>
                {filename}
            </div>
            <div className="snippet__inner">
                <div dangerouslySetInnerHTML={{__html: md.render(markdown)}} />
            </div>
        </div>
    )
}

export default Snippet;